import { Divider, AppShell } from "@mantine/core";
import { FC } from "react";
import { NavItem } from "../../../../Components/NavItem";
import {
  IconBallFootball,
  IconBrandInstagram,
  IconBrandTiktok,
  IconBrandYoutube,
  IconCalendarClock,
  IconExternalLink,
  IconMessageCircle,
  IconShirtSport,
  IconSoccerField,
  IconTable,
} from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin.ts";

export const Navigation: FC = () => {
  const location = useLocation();
  const { links, leaderboardPages } = getPresentationParamsForOrigin();

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(`/${path}`);
  };

  return (
    <AppShell.Navbar
      visibleFrom="sm"
      style={{
        padding: "var(--mantine-spacing-md)",
        paddingInlineStart:
          "calc(var(--mantine-spacing-md) + env(safe-area-inset-left, 0px))",
        paddingBottom:
          "calc(var(--mantine-spacing-md) + env(safe-area-inset-bottom, 0px))",
      }}
    >
      <NavItem
        to="/"
        color="fwcBlue"
        icon={<IconSoccerField size="1rem" />}
        label="Startseite"
        active={isActive("/")}
      />
      <NavItem
        to="/games"
        color="fwcBlue"
        icon={<IconCalendarClock size="1rem" />}
        label="Spiele"
        active={isActive("games")}
      />
      <NavItem
        to="/teams"
        color="fwcBlue"
        icon={<IconShirtSport size="1rem" />}
        label="Mannschaften"
        active={isActive("teams")}
      />
      <NavItem
        to="/topscorer"
        color="fwcBlue"
        icon={<IconBallFootball size="1rem" />}
        label="Topscorer"
        active={isActive("topscorer")}
      />
      {leaderboardPages.map((l) => (
        <NavItem
          key={l.key}
          to={`/leaderboard/${l.key}`}
          color="fwcBlue"
          icon={<IconTable size="1rem" />}
          label={l.title}
          active={location.pathname === `/leaderboard/${l.key}`}
        />
      ))}

      <Divider my="sm" />

      {links.feedback && (
        <>
          <NavItem
            href={links.feedback}
            color="fwcBlue"
            icon={<IconMessageCircle size="1rem" />}
            label="Feedback zur App"
          />
          <Divider my="sm" />
        </>
      )}
      {links.website && (
        <NavItem
          href={links.website}
          color="fwcBlue"
          icon={<IconExternalLink size="1rem" />}
          label="Zur Website"
        />
      )}
      {links.magazine && (
        <NavItem
          href={links.magazine}
          color="fwcBlue"
          icon={<IconExternalLink size="1rem" />}
          label="Turnier-Magazin"
        />
      )}
      {links.instagram && (
        <NavItem
          href={links.instagram}
          color="fwcBlue"
          icon={<IconBrandInstagram size="1rem" />}
          label="Instagram"
        />
      )}
      {links.tiktok && (
        <NavItem
          href={links.tiktok}
          color="fwcBlue"
          icon={<IconBrandTiktok size="1rem" />}
          label="TikTok"
        />
      )}
      {links.youtube && (
        <NavItem
          href={links.youtube}
          color="fwcBlue"
          icon={<IconBrandYoutube size="1rem" />}
          label="Youtube"
        />
      )}
    </AppShell.Navbar>
  );
};
